import axios from 'axios';
import qs from 'qs';

export const CompanyHeader = 'CurrentCompanySelected';
export const MarketHeader = 'CurrentMarketSelected';
export const CompanyEmployeeRoleHeader = 'CurrentEmployeeRole';

export const updateAxiosAuthorization = (accessToken?: string): void => {
  if (!accessToken) {
    delete axios.defaults.headers.common['Authorization'];
  } else {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
  }
  axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
  axios.defaults.headers.common['Access-Control-Allow-Headers'] =
    `Origin, X-Requested-With, Content-Type, Accept`;
  axios.defaults.headers.common['Content-Type'] = `application/json`;
  axios.defaults.withCredentials = true;
  axios.defaults.paramsSerializer = (params): string => {
    return qs.stringify(params);
  };
};

export const AddAxiosHeaderParam = (param: string, value: string | undefined): void => {
  if (value != null) {
    axios.defaults.headers.common[param] = value;
  } else {
    delete axios.defaults.headers.common[param];
  }
};
